module.exports = __webpack_public_path__ + "img/invite-customer-steps.be71e59e.png";